import styled from "styled-components";

export const StyledRedesignButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  border: none;
  cursor: pointer;
  border-radius: 9999px;
  padding: 0.375rem 0.375rem 0.375rem 1.25rem;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.9375rem;
  text-decoration: none;
  transition: transform 0.2s ease, background-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  .redesign-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    flex-shrink: 0;
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 0.5rem 0.5rem 0.5rem 1.75rem;
    font-size: 1.0625rem;
    gap: 1rem;
    .redesign-btn-icon {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  ${({ $variant, theme }) =>
    $variant === "dark"
      ? `
        background-color: ${theme.palette.redesign.black};
        color: ${theme.palette.redesign.white};
        .redesign-btn-icon {
          background-color: ${theme.palette.redesign.white};
          color: ${theme.palette.redesign.black};
        }
        &:hover {
          background-color: #000;
        }
      `
      : `
        background-color: ${theme.palette.redesign.pink};
        color: ${theme.palette.redesign.black};
        .redesign-btn-icon {
          background-color: ${theme.palette.redesign.black};
          color: ${theme.palette.redesign.pink};
        }
        &:hover {
          background-color: ${theme.palette.redesign.pink};
          color: ${theme.palette.redesign.white};
        }
      `}
`;
